import { auth } from "../firebase/config";

const createUser = async (email: string, password: string) => {
  try {
    const res = await auth.createUserWithEmailAndPassword(email, password);
    return res;
  } catch (error) {
    throw error;
  }
};

export default createUser;
